import React from 'react';
import './skewed-background.scss';
export function SkewedBackground() {
  return(
    <div className='skewed-background'/>
  );
}
